import { FC, useEffect, useState } from 'react';
import { ITabState } from '../../../states/tabState.model.ts';
import {
  bakery2bStatisticState,
  initialBakery2bStatisticTabState,
} from '../../../states/bakery2bStatistic.state.ts';
import { storageHelper } from '../../../../../../shared/helpers/storage';
import {
  Column,
  Footer,
} from '../../../../../../shared/components/table/components/common.components.tsx';
import { Table } from '../../../../../../shared/components/table/table.component.tsx';
import { useTranslation } from 'react-i18next';
import { DateRangePicker } from '../../../../../../shared/components/datePicker/dateRangePicker.component.tsx';
import { format } from 'date-fns';
import { localeFormatterHelper } from '../../../../../../shared/helpers/formatter/localeFormatter.helper.ts';

export const StatisticTab: FC<IStatisticTab> = ({ params }) => {
  const { t } = useTranslation();
  const { statisticList, statisticListSortModel } = params;
  const [gridData, setGridData] = useState(statisticList);
  const [loading, setLoading] = useState(false);
  const [sortModel, setSortModel] = useState(statisticListSortModel);
  const [allStatisticListLength, setAllStatisticListLength] = useState(statisticList.length);
  useEffect(() => {
    bakery2bStatisticState.pub.init({ statisticList, statisticListSortModel });
    const bakery2bStatisticStateSub = bakery2bStatisticState.sub
      .state()
      .subscribe(({ statisticList, statisticListSortModel, allStatisticListLength }) => {
        setGridData(statisticList);
        setSortModel(statisticListSortModel);
        setAllStatisticListLength(allStatisticListLength);
      });
    const loadingSub = bakery2bStatisticState.sub.gridLoading().subscribe(setLoading);
    return () => {
      bakery2bStatisticStateSub.unsubscribe();
      loadingSub.unsubscribe();
    };
  }, []);
  return (
    <Table
      data={gridData}
      defaultSorting={sortModel}
      replacedId='email'
      initialState={{
        columns: storageHelper.local.getItem('bakery2bStatistic.customerColumnModel'),
      }}
      onSort={(sortModel) => {
        bakery2bStatisticState.pub.sort(sortModel);
        storageHelper.local.setItem('bakery2bStatistic.sortModel', sortModel);
      }}
      onSearch={(search) => bakery2bStatisticState.pub.search(search)}
      searchStyles={{ maxWidth: '40%', marginBottom: 0 }}
      searchWrapperStyle={{
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: '8px',
        gap: 2,
      }}
      onChangeColumnModel={(v) =>
        storageHelper.local.setItem('bakery2bStatistic.customerColumnModel', v)
      }
      childrenButtons={() => (
        <DateRangePicker
          defaultValue={{
            fromDate: localeFormatterHelper.localizedDate(
              initialBakery2bStatisticTabState.dateRange.fromDate,
            ),
            toDate: localeFormatterHelper.localizedDate(
              initialBakery2bStatisticTabState.dateRange.toDate,
            ),
          }}
          width={270}
          onChange={(datePeriod) => {
            bakery2bStatisticState.pub.getStatisticList({
              fromDate: format(datePeriod.fromDate || new Date(), 'yyyy-MM-dd'),
              toDate: datePeriod.toDate ? format(datePeriod.toDate, 'yyyy-MM-dd') : null,
            });
          }}
        />
      )}
      heightOffset={169}
      {...{ loading }}
    >
      <Column field='email' headerName={t('common.email')} width={260} />
      <Column field='name' headerName={t('common.name')} flex={1} minWidth={100} />
      <Column
        field='newBakery2bOrders'
        headerName={t('settings.orders_from_new_bakery2b')}
        width={210}
        headerAlign='right'
        align='right'
      />
      <Column
        field='orders'
        headerName={t('settings.orders_in_period')}
        width={160}
        headerAlign='right'
        align='right'
      />
      <Column
        field='totalOrders'
        headerName={t('settings.orders_from_beginning')}
        width={200}
        headerAlign='right'
        align='right'
      />
      <Footer
        numberRows={gridData.length}
        allNumbersRow={allStatisticListLength}
        titleRows={t('settings.client', { count: gridData.length })}
        onRefresh={() => bakery2bStatisticState.pub.refreshStatisticList()}
        refreshSx={{ marginRight: 7 }}
      />
    </Table>
  );
};

export interface IStatisticTab {
  params: Pick<ITabState, 'statisticList' | 'statisticListSortModel'>;
}
